module.exports = __webpack_public_path__ + "img/interaction-bar-search-ford.2dc5a6c4.png";